// extracted by mini-css-extract-plugin
module.exports = {"divButtonReviewPrompt":"styles_divButtonReviewPrompt__2jb-2","iconLoading":"styles_iconLoading__2Eorc"};